<section class="section grey-100" *ngIf="applyData">
  <div class="section-container-small">
    <div class="align-c">
      <h2 class="section-heading mar-b-48">{{ applyData?.title }}</h2>
    </div>
    <div
      class="section-description mar-b-48 align-c"
      [innerHtml]="applyData?.content | toHtml"
    ></div>
    <div id="hubspotDownloadForm" class="w-100"></div>
  </div>
</section>
